import { useState, useEffect, useMemo, useCallback } from 'react'
import {
  Container,
  Grid,
  makeStyles,
  useMediaQuery,
  useTheme,
  Backdrop,
  CircularProgress,
  Box,
} from '@material-ui/core'
import Axios from 'axios'
import { useRouter } from 'next/router'
import Layout from '../components/common/Layout'
import CheckpriceNew from '../components/pages-new/CheckpriceNew'
import CheckpriceForm from '../components/checkprice/CheckpriceForm'
import ResultCard from '../components/checkprice/ResultCard'
import FilterCard from '../components/checkprice/FilterCard'
import SearchIcon from '@material-ui/icons/Search'
import EB_Checkprice from '../components/externalBanner/EB_Checkprice'

import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const useStyles = makeStyles((theme) => ({
  heroImg: {
    backgroundImage: 'url("/static/img/home/home_desktop.jpg")',
    backgroundPosition: 'top right',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#4C3C52',
    padding: `${theme.spacing(4)}px 0`,
  },
  title: {
    marginTop: 46,
    fontWeight: 400,
    ...theme.headerFont,
  },
  errorTitle: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 40,
    marginTop: theme.spacing(10),
    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
      marginTop: theme.spacing(5),
    },
  },
  errorSubtitle: {
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 32,
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
      marginBottom: theme.spacing(5),
    },
  },
}))

const CheckPricePageOld = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyles()

  const { t } = useTranslation('checkprice')

  const [checkpriceResultList, setCheckpriceResultList] = useState([])
  const [resultStatus, setResultStatus] = useState('ready')
  const [lastFetchBody, setLastFetchBody] = useState(null)
  const [selectedLlmServiceType, setSelectedLlmServiceType] = useState('MOTORCYCLE')
  // ^ ready = not show any result yet wait for user action, error = show error not found, loading = fetching, success = show results
  const [resultDeliveryType, setResultDeliveryType] = useState('domestic')
  // ^ used to keep track that the results shown is from domestic or inter search
  const [filterState, setFilterState] = useState({
    p50down: false,
    p50to100: false,
    p101to150: false,
    p150up: false,
    pickup: false,
    dropoff: false,
    d1down: false,
    d2to3: false,
    d4to5: false,
    d6to7: false,
    d8to14: false,
    d15up: false,
  })

  const [interFilterState, setInterFilterState] = useState({
    p150to500: false,
    p501to1000: false,
    p1001to2000: false,
    p2000up: false,
    pickup: false,
    dropoff: false,
    d1down: false,
    d2to3: false,
    d4to5: false,
    d6to7: false,
    d8to14: false,
    d15up: false,
  })

  const refetchWithServiceType = useCallback(async (serviceType) => {
    if (!lastFetchBody) return
    setSelectedLlmServiceType(serviceType)
    setResultStatus('loading')
    try {
      const res = await Axios.post('/api/checkprice/fetch', {
        ...lastFetchBody,
        service_type: serviceType,
      })
      setResultStatus('success')
      setHandlerCheckpriceResultList(res.data)
    } catch (err) {
      setResultStatus('error')
    }
  }, [lastFetchBody])

  // know the results is inter or domestic by check deliveryType of first result

  const setHandlerCheckpriceResultList = (data) => {
    try {
      const newData = data.map((d) => {
        return { ...d, isBanner: false }
      })

      newData.splice(2, 0, { isBanner: true })
      setCheckpriceResultList(() => newData)
    } catch (err) {
      console.error(err.message)
    }
  }

  useEffect(() => {
    if (!Array.isArray(checkpriceResultList)) return
    if (checkpriceResultList.length < 1) return
    if (!checkpriceResultList[0].deliveryType) return
    setResultDeliveryType(
      checkpriceResultList[0].deliveryType === 'inter' ? 'inter' : 'domestic'
    )
  }, [checkpriceResultList])

  const resultsFilter = (result) => {
    const {
      p50down,
      p50to100,
      p101to150,
      p150up,
      pickup,
      dropoff,
      d1down,
      d2to3,
      d4to5,
      d6to7,
      d8to14,
      d15up,
    } = filterState
    const notSelectAnyPrice = !p50down && !p50to100 && !p101to150 && !p150up
    const notSelectAnyDuration =
      !d1down && !d2to3 && !d4to5 && !d6to7 && !d8to14 && !d15up
    const notSelectPickupOrDropoff = !pickup && !dropoff

    if (!notSelectAnyPrice) {
      if (result.price < 50) {
        if (!p50down) return false
      } else if (result.price < 101) {
        if (!p50to100) return false
      } else if (result.price < 151) {
        if (!p101to150) return false
      } else if (result.price >= 151) {
        if (!p150up) return false
      } else return false
    }

    if (!notSelectPickupOrDropoff) {
      switch (result.pickupType) {
        case 'pick-up':
          if (!pickup) return false
          break
        case 'drop-off':
          if (!dropoff) return false
          break
        case 'pick-up-or-drop-off':
          break
        default:
          return false
      }
    }

    if (!notSelectAnyDuration) {
      if (!result.timeMax) return false
      if (result.timeMax === 1) {
        if (!d1down) return false
      } else if (result.timeMax <= 3) {
        if (!d2to3) return false
      } else if (result.timeMax <= 5) {
        if (!d4to5) return false
      } else if (result.timeMax <= 7) {
        if (!d6to7) return false
      } else if (result.timeMax <= 14) {
        if (!d8to14) return false
      } else if (result.timeMax > 14) {
        if (!d15up) return false
      } else return false
    }

    return true // true means this result should show, false means should hide
  }

  const interResultsFilter = (result) => {
    const {
      p150to500,
      p501to1000,
      p1001to2000,
      p2000up,
      pickup,
      dropoff,
      d1down,
      d2to3,
      d4to5,
      d6to7,
      d8to14,
      d15up,
    } = interFilterState
    const notSelectAnyPrice =
      !p150to500 && !p501to1000 && !p1001to2000 && !p2000up
    const notSelectAnyDuration =
      !d1down && !d2to3 && !d4to5 && !d6to7 && !d8to14 && !d15up
    const notSelectPickupOrDropoff = !pickup && !dropoff

    if (!notSelectAnyPrice) {
      if (result.price < 501) {
        if (!p150to500) return false
      } else if (result.price < 1001) {
        if (!p501to1000) return false
      } else if (result.price < 2001) {
        if (!p1001to2000) return false
      } else if (result.price >= 2001) {
        if (!p2000up) return false
      } else return false
    }

    if (!notSelectPickupOrDropoff) {
      switch (result.pickupType) {
        case 'pick-up':
          if (!pickup) return false
          break
        case 'drop-off':
          if (!dropoff) return false
          break
        case 'pick-up-or-drop-off':
          break
        default:
          return false
      }
    }

    if (!notSelectAnyDuration) {
      if (result.timeMax <= 1) {
        if (!d1down) return false
      } else if (result.timeMax <= 3) {
        if (!d2to3) return false
      } else if (result.timeMax <= 5) {
        if (!d4to5) return false
      } else if (result.timeMax <= 7) {
        if (!d6to7) return false
      } else if (result.timeMax <= 14) {
        if (!d8to14) return false
      } else if (result.timeMax > 14) {
        if (!d15up) return false
      } else return false
    }

    return true // true means this result should show, false means should hide
  }

  const newCheckpriceResultList = useMemo(() => {
    const newData = checkpriceResultList.map((d) => {
      return { ...d, isBanner: false }
    })

    newData.splice(2, 0, { isBanner: true })
    return newData
  }, [checkpriceResultList])

  const BANED_COURIER_CODE = ['JWDC', 'JWDF' ,'CJE', 'JNTP', 'JNTPF', 'JNTD', 'BEE', 'SCG']

  const removeBannedCourier = newCheckpriceResultList.filter((data) => {
    if (data.isBanner) {
      return true
    } else {
      return !BANED_COURIER_CODE.includes(data.courierCode)
    }
  })

  return (
    <>
      <div>
        <Layout
          title="SHIPPOP เปรียบเทียบราคาค่าส่งพัสดุ เช็คราคา ส่งของ จองขนส่ง ทำได้เลยทันที"
          keywords="เปรียบเทียบราคา, ค่าส่งพัสดุ, เช็คค่าส่งของ, เช็คราคาส่งพัสดุ, ส่งของราคาถูก, อัตราค่าส่ง,ค่าส่ง"
          description="เปรียบเทียบราคาอัตราค่าส่งพัสดุ เช็คค่าส่ง ส่งของราคาถูก เปรียบเทียบจากหลากหลายเจ้ามากกว่า 20+ ขนส่งได้ที่นี้ที่เดียว ไม่ต้องเสียเวลาหาข้อมูลเปรียบเทียบด้วยตัวเอง เช็คราคาได้เลยทันทีกับ SHIPPOP"
        >
          <div className={classes.heroImg}>
            <Container>
              <CheckpriceForm
                submitMode="fetch"
                setCheckpriceResultList={setCheckpriceResultList}
                setResultStatus={setResultStatus}
                setLastFetchBody={setLastFetchBody}
              />
            </Container>
          </div>
          <Container>
            {resultStatus === 'success' && (
              <>
                <h3 className={classes.title}>{t('all-couriers-list')}</h3>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={3}>
                    <FilterCard
                      setFilterState={setFilterState}
                      setInterFilterState={setInterFilterState}
                      filterState={filterState}
                      interFilterState={interFilterState}
                      deliveryType={resultDeliveryType}
                    />
                  </Grid>
                  <Grid
                    container
                    item
                    xs={12}
                    md={9}
                    direction="column"
                    alignItems="center"
                  >
                    {resultStatus === 'success' &&
                      removeBannedCourier.map((data, index) => {
                        const { isBanner } = data
                        return (
                          <>
                            {!isBanner && (
                              <ResultCard
                                condition={data.condition}
                                timeMin={data.timeMin}
                                timeMax={data.timeMax}
                                pickupType={data.pickupType}
                                price={data.price}
                                remark={data.notice}
                                courierImg={data.courierImg}
                                courierName={data.courierName}
                                error={data.error}
                                courierCondition={data.courierCondition}
                                courierDetail={data.courierDetail}
                                hidden={
                                  resultDeliveryType === 'inter'
                                    ? !interResultsFilter(data)
                                    : !resultsFilter(data)
                                }
                                recommended={index === 0 && !data.error}
                                key={`${data.courierName} ${data.price}`}
                                durationString={data.durationString}
                                deliveryType={data.deliveryType}
                                courierCode={data.courierCode}
                                onServiceTypeChange={refetchWithServiceType}
                                selectedLlmServiceType={selectedLlmServiceType}
                              />
                            )}
                            {isBanner && <EB_Checkprice />}
                          </>
                        )
                      })}
                    {/* case all results have been filtered */}
                    {resultStatus === 'success' &&
                      checkpriceResultList.filter(
                        resultDeliveryType === 'inter'
                          ? interResultsFilter
                          : resultsFilter
                      ).length == 0 && (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          color="#828282"
                        >
                          <img
                            src="/static/img/not-found.svg"
                            width={isMobile ? 250 : 500}
                            alt=""
                          />
                          <h2 className={classes.errorSubtitle}>
                            {t('no-filtered-result')}
                          </h2>
                        </Box>
                      )}
                  </Grid>
                </Grid>
              </>
            )}
            {resultStatus === 'error' && (
              <>
                <h1 className={classes.errorTitle}>
                  <SearchIcon
                    style={{
                      width: isMobile ? 20 : 40,
                      height: isMobile ? 20 : 40,
                      marginRight: theme.spacing(1),
                    }}
                  />{' '}
                  {t('an-error-occured')}
                </h1>
                <h2 className={classes.errorSubtitle}>
                  {t('please-try-again')}
                </h2>
              </>
            )}
          </Container>
        </Layout>
      </div>
      <Backdrop open={resultStatus === 'loading'} style={{ zIndex: 99999 }}>
        <CircularProgress />
      </Backdrop>
    </>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'checkprice',
    ])),
  },
})

// ?new → new-design variant (new chrome, same content); otherwise the old
// page renders unchanged. Wrapper keeps hook order stable across both paths
// (each branch is its own component, so neither shares the other's hooks).
const CheckPricePage = (props) => {
  const { query } = useRouter()
  if ('old' in query) return <CheckPricePageOld {...props} />
  return <CheckpriceNew {...props} />
}

export default CheckPricePage
